import { Directive, OnDestroy, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
    selector: '[appPreventScroll]',
    standalone: true
})
export class PreventScrollDirective implements OnInit, OnDestroy {
    private static instanceCount = 0;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2
    ) { }

    ngOnInit() {
        PreventScrollDirective.instanceCount++;
        if (PreventScrollDirective.instanceCount === 1) {
            this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
            this.renderer.setStyle(this.document.documentElement, 'overflow', 'hidden');
        }
    }

    ngOnDestroy() {
        PreventScrollDirective.instanceCount--;
        if (PreventScrollDirective.instanceCount === 0) {
            this.renderer.removeStyle(this.document.body, 'overflow');
            this.renderer.removeStyle(this.document.documentElement, 'overflow');
        }
    }
}
